import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import OECDRegions from '../views/OECDRegions.vue'
import SubArea from '../views/SubArea.vue'
import SubAreaChart from '../views/SubAreaChart.vue'
import MetroRegional from '../views/MetroRegional.vue'
import MetroRegionalChart from '../views/MetroRegionalChart.vue'
// import DataTable from '../views/DataTable.vue'

Vue.use(VueRouter)
  
  const routes = [
    /*
    {
      path: '/datatable/:tl/:c/:tu/:indicod/:year',
      name: 'DataTable',
      component: DataTable,
      props: true 
    },
    */
    {
      path: '/oecdregions/:tl/:c/:tu/:indicod/:year',
      name: 'OECDRegions',
      component: OECDRegions,
      props: true 
    },
    {
      path: '/subarea/:tl/:c/:tu/:indicod/:year',
      name: 'SubArea',
      component: SubArea,
      props: true 
    },
    {
      path: '/subareachart/:tl/:c/:tu/:indicod/:year',
      name: 'SubAreaChart',
      component: SubAreaChart,
      props: true 
    },
    {
      path: '/metroregional/:tl/:c/:tu/:indicod/:year/:ctu',
      name: 'MetroRegional',
      component: MetroRegional,
      props: true 
    },
    {
      path: '/metroregionalchart/:tl/:c/:tu/:indicod/:year/:ctu',
      name: 'MetroRegionalChart',
      component: MetroRegionalChart,
      props: true 
    },  
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/:tl/:c/:tu/:indicod/:year',
      name: 'Home',
      component: Home
    }
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


/*
const DEFAULT_TITLE = 'OECD Atlas'
router.afterEach((to, from) => {
    console.log(to,from)
    Vue.nextTick(() => {
        document.title = DEFAULT_TITLE
    })
})
*/


export default router
